import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PropertyPIITag = /*#__PURE__*/function (PropertyPIITag) {
  PropertyPIITag[PropertyPIITag["PROPERTY_PII_TAG_CLEAN"] = 0] = "PROPERTY_PII_TAG_CLEAN";
  PropertyPIITag[PropertyPIITag["PROPERTY_PII_TAG_PII"] = 1] = "PROPERTY_PII_TAG_PII";
  PropertyPIITag[PropertyPIITag["PROPERTY_PII_TAG_PD"] = 2] = "PROPERTY_PII_TAG_PD";
  return PropertyPIITag;
}(PropertyPIITag || {});
var PropertyType = /*#__PURE__*/function (PropertyType) {
  PropertyType[PropertyType["PROPERTY_TYPE_STRING"] = 0] = "PROPERTY_TYPE_STRING";
  PropertyType[PropertyType["PROPERTY_TYPE_INT64"] = 1] = "PROPERTY_TYPE_INT64";
  PropertyType[PropertyType["PROPERTY_TYPE_DOUBLE"] = 2] = "PROPERTY_TYPE_DOUBLE";
  PropertyType[PropertyType["PROPERTY_TYPE_BOOL"] = 3] = "PROPERTY_TYPE_BOOL";
  PropertyType[PropertyType["PROPERTY_TYPE_TIMESTAMP"] = 4] = "PROPERTY_TYPE_TIMESTAMP";
  PropertyType[PropertyType["PROPERTY_TYPE_GEOPOINT"] = 5] = "PROPERTY_TYPE_GEOPOINT";
  PropertyType[PropertyType["PROPERTY_TYPE_STRUCT"] = 6] = "PROPERTY_TYPE_STRUCT";
  PropertyType[PropertyType["PROPERTY_TYPE_BYTES"] = 7] = "PROPERTY_TYPE_BYTES";
  return PropertyType;
}(PropertyType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Alignment = /*#__PURE__*/function (Alignment) {
  Alignment[Alignment["ALIGN_NONE"] = 0] = "ALIGN_NONE";
  Alignment[Alignment["ALIGN_DELTA"] = 1] = "ALIGN_DELTA";
  Alignment[Alignment["ALIGN_INTERPOLATE"] = 3] = "ALIGN_INTERPOLATE";
  Alignment[Alignment["ALIGN_NEXT_OLDER"] = 4] = "ALIGN_NEXT_OLDER";
  Alignment[Alignment["ALIGN_EXACT"] = 5] = "ALIGN_EXACT";
  Alignment[Alignment["ALIGN_CUSTOM"] = 6] = "ALIGN_CUSTOM";
  return Alignment;
}(Alignment || {});
var AlignmentPeriodCalendar = /*#__PURE__*/function (AlignmentPeriodCalendar) {
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_MINUTE"] = 1] = "CALENDAR_MINUTE";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_HOUR"] = 2] = "CALENDAR_HOUR";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_DAY"] = 3] = "CALENDAR_DAY";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_WEEK"] = 4] = "CALENDAR_WEEK";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_MONTH"] = 5] = "CALENDAR_MONTH";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_QUARTER"] = 6] = "CALENDAR_QUARTER";
  AlignmentPeriodCalendar[AlignmentPeriodCalendar["CALENDAR_YEAR"] = 7] = "CALENDAR_YEAR";
  return AlignmentPeriodCalendar;
}(AlignmentPeriodCalendar || {});
var Metric = /*#__PURE__*/function (Metric) {
  Metric[Metric["CONNECTED_GMB_ACCOUNTS"] = 0] = "CONNECTED_GMB_ACCOUNTS";
  Metric[Metric["QUERIES_DIRECT"] = 1] = "QUERIES_DIRECT";
  Metric[Metric["QUERIES_INDIRECT"] = 2] = "QUERIES_INDIRECT";
  Metric[Metric["VIEWS_MAPS"] = 3] = "VIEWS_MAPS";
  Metric[Metric["VIEWS_SEARCH"] = 4] = "VIEWS_SEARCH";
  Metric[Metric["ACTIONS_WEBSITE"] = 5] = "ACTIONS_WEBSITE";
  Metric[Metric["ACTIONS_PHONE"] = 6] = "ACTIONS_PHONE";
  Metric[Metric["ACTIONS_DRIVING_DIRECTIONS"] = 7] = "ACTIONS_DRIVING_DIRECTIONS";
  Metric[Metric["TOTAL_LISTINGS"] = 8] = "TOTAL_LISTINGS";
  Metric[Metric["TOTAL_INACCURATE_LISTINGS"] = 9] = "TOTAL_INACCURATE_LISTINGS";
  Metric[Metric["TOTAL_CITATIONS"] = 10] = "TOTAL_CITATIONS";
  Metric[Metric["TOTAL_REVIEWS"] = 11] = "TOTAL_REVIEWS";
  Metric[Metric["NEW_REVIEWS"] = 12] = "NEW_REVIEWS";
  Metric[Metric["NEW_POSITIVE_REVIEWS"] = 13] = "NEW_POSITIVE_REVIEWS";
  Metric[Metric["NEW_POSITIVE_UNRESPONDED_REVIEWS"] = 14] = "NEW_POSITIVE_UNRESPONDED_REVIEWS";
  Metric[Metric["NEW_NEGATIVE_REVIEWS"] = 15] = "NEW_NEGATIVE_REVIEWS";
  Metric[Metric["NEW_NEGATIVE_UNRESPONDED_REVIEWS"] = 16] = "NEW_NEGATIVE_UNRESPONDED_REVIEWS";
  Metric[Metric["NEW_POSITIVE_RESPONDED_REVIEWS"] = 17] = "NEW_POSITIVE_RESPONDED_REVIEWS";
  Metric[Metric["AVERAGE_REVIEW_RATING"] = 18] = "AVERAGE_REVIEW_RATING";
  Metric[Metric["LMI_GRADE_LISTINGS"] = 19] = "LMI_GRADE_LISTINGS";
  Metric[Metric["LMI_GRADE_REPUTATION"] = 20] = "LMI_GRADE_REPUTATION";
  Metric[Metric["LMI_GRADE_SOCIAL"] = 21] = "LMI_GRADE_SOCIAL";
  Metric[Metric["LMI_GRADE_SEO"] = 22] = "LMI_GRADE_SEO";
  Metric[Metric["LISTING_SYNC_SITES_CURRENTLY_SYNCING"] = 23] = "LISTING_SYNC_SITES_CURRENTLY_SYNCING";
  Metric[Metric["LISTING_SYNC_SITES_TOTAL"] = 24] = "LISTING_SYNC_SITES_TOTAL";
  return Metric;
}(Metric || {});
var CompositeFilterOperator = /*#__PURE__*/function (CompositeFilterOperator) {
  CompositeFilterOperator[CompositeFilterOperator["OPERATOR_UNSPECIFIED"] = 0] = "OPERATOR_UNSPECIFIED";
  CompositeFilterOperator[CompositeFilterOperator["AND"] = 1] = "AND";
  CompositeFilterOperator[CompositeFilterOperator["OR"] = 2] = "OR";
  return CompositeFilterOperator;
}(CompositeFilterOperator || {});
var UnaryFilterOperator = /*#__PURE__*/function (UnaryFilterOperator) {
  UnaryFilterOperator[UnaryFilterOperator["OPERATOR_UNSPECIFIED"] = 0] = "OPERATOR_UNSPECIFIED";
  UnaryFilterOperator[UnaryFilterOperator["IS_NAN"] = 2] = "IS_NAN";
  UnaryFilterOperator[UnaryFilterOperator["IS_NULL"] = 3] = "IS_NULL";
  UnaryFilterOperator[UnaryFilterOperator["IS_NOT_NULL"] = 4] = "IS_NOT_NULL";
  return UnaryFilterOperator;
}(UnaryFilterOperator || {});
var MeasureAggregateOperator = /*#__PURE__*/function (MeasureAggregateOperator) {
  MeasureAggregateOperator[MeasureAggregateOperator["AVG"] = 0] = "AVG";
  MeasureAggregateOperator[MeasureAggregateOperator["COUNT"] = 1] = "COUNT";
  MeasureAggregateOperator[MeasureAggregateOperator["SUM"] = 2] = "SUM";
  MeasureAggregateOperator[MeasureAggregateOperator["MIN"] = 3] = "MIN";
  MeasureAggregateOperator[MeasureAggregateOperator["MAX"] = 4] = "MAX";
  MeasureAggregateOperator[MeasureAggregateOperator["COUNT_DISTINCT"] = 5] = "COUNT_DISTINCT";
  MeasureAggregateOperator[MeasureAggregateOperator["ARRAY_AGG"] = 6] = "ARRAY_AGG";
  return MeasureAggregateOperator;
}(MeasureAggregateOperator || {});
var GroupByOperator = /*#__PURE__*/function (GroupByOperator) {
  GroupByOperator[GroupByOperator["OPERATOR_GROUP_BY"] = 0] = "OPERATOR_GROUP_BY";
  GroupByOperator[GroupByOperator["OPERATOR_ROLLUP"] = 1] = "OPERATOR_ROLLUP";
  GroupByOperator[GroupByOperator["OPERATOR_CUBE"] = 2] = "OPERATOR_CUBE";
  return GroupByOperator;
}(GroupByOperator || {});
var FieldFilterOperator = /*#__PURE__*/function (FieldFilterOperator) {
  FieldFilterOperator[FieldFilterOperator["OPERATOR_UNSPECIFIED"] = 0] = "OPERATOR_UNSPECIFIED";
  FieldFilterOperator[FieldFilterOperator["LESS_THAN"] = 1] = "LESS_THAN";
  FieldFilterOperator[FieldFilterOperator["LESS_THAN_OR_EQUAL"] = 2] = "LESS_THAN_OR_EQUAL";
  FieldFilterOperator[FieldFilterOperator["GREATER_THAN"] = 3] = "GREATER_THAN";
  FieldFilterOperator[FieldFilterOperator["GREATER_THAN_OR_EQUAL"] = 4] = "GREATER_THAN_OR_EQUAL";
  FieldFilterOperator[FieldFilterOperator["EQUAL"] = 5] = "EQUAL";
  FieldFilterOperator[FieldFilterOperator["OVERLAP"] = 6] = "OVERLAP";
  FieldFilterOperator[FieldFilterOperator["NOT_EQUAL"] = 7] = "NOT_EQUAL";
  return FieldFilterOperator;
}(FieldFilterOperator || {});
var FieldFilterOperatorFunction = /*#__PURE__*/function (FieldFilterOperatorFunction) {
  FieldFilterOperatorFunction[FieldFilterOperatorFunction["NONE"] = 0] = "NONE";
  FieldFilterOperatorFunction[FieldFilterOperatorFunction["ANY"] = 1] = "ANY";
  FieldFilterOperatorFunction[FieldFilterOperatorFunction["ALL"] = 2] = "ALL";
  return FieldFilterOperatorFunction;
}(FieldFilterOperatorFunction || {});
var Order = /*#__PURE__*/function (Order) {
  Order[Order["ORDER_ASC"] = 0] = "ORDER_ASC";
  Order[Order["ORDER_DESC"] = 1] = "ORDER_DESC";
  return Order;
}(Order || {});
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Property {
  static fromProto(proto) {
    let m = new Property();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$1(PropertyType, proto.type);
    }
    if (proto.properties) {
      m.properties = proto.properties.map(Property.fromProto);
    }
    if (proto.piiTag) {
      m.piiTag = enumStringToValue$1(PropertyPIITag, proto.piiTag);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.repeated !== 'undefined') {
      toReturn['repeated'] = this.repeated;
    }
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    if (typeof this.piiTag !== 'undefined') {
      toReturn['piiTag'] = this.piiTag;
    }
    return toReturn;
  }
}
class Schema {
  static fromProto(proto) {
    let m = new Schema();
    m = Object.assign(m, proto);
    if (proto.properties) {
      m.properties = proto.properties.map(Property.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.properties !== 'undefined' && this.properties !== null) {
      toReturn['properties'] = 'toApiJson' in this.properties ? this.properties.toApiJson() : this.properties;
    }
    return toReturn;
  }
}
class TypedStruct {
  static fromProto(proto) {
    let m = new TypedStruct();
    m = Object.assign(m, proto);
    if (proto.schema) {
      m.schema = Schema.fromProto(proto.schema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.schema !== 'undefined' && this.schema !== null) {
      toReturn['schema'] = 'toApiJson' in this.schema ? this.schema.toApiJson() : this.schema;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MeasureAggregate {
  static fromProto(proto) {
    let m = new MeasureAggregate();
    m = Object.assign(m, proto);
    if (proto.aggOp) {
      m.aggOp = enumStringToValue(MeasureAggregateOperator, proto.aggOp);
    }
    if (proto.filter) {
      m.filter = Filter.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.measure !== 'undefined') {
      toReturn['measure'] = this.measure;
    }
    if (typeof this.aggOp !== 'undefined') {
      toReturn['aggOp'] = this.aggOp;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.alias !== 'undefined') {
      toReturn['alias'] = this.alias;
    }
    return toReturn;
  }
}
class AlignmentPeriod {
  static fromProto(proto) {
    let m = new AlignmentPeriod();
    m = Object.assign(m, proto);
    if (proto.calendar) {
      m.calendar = enumStringToValue(AlignmentPeriodCalendar, proto.calendar);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.calendar !== 'undefined') {
      toReturn['calendar'] = this.calendar;
    }
    return toReturn;
  }
}
class BusinessResourceId {
  static fromProto(proto) {
    let m = new BusinessResourceId();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CompositeFilter {
  static fromProto(proto) {
    let m = new CompositeFilter();
    m = Object.assign(m, proto);
    if (proto.op) {
      m.op = enumStringToValue(CompositeFilterOperator, proto.op);
    }
    if (proto.filters) {
      m.filters = proto.filters.map(Filter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.op !== 'undefined') {
      toReturn['op'] = this.op;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class CustomAlignerConfig {
  static fromProto(proto) {
    let m = new CustomAlignerConfig();
    m = Object.assign(m, proto);
    if (proto.alignmentBucketFilter) {
      m.alignmentBucketFilter = Filter.fromProto(proto.alignmentBucketFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.alignmentBucketFilter !== 'undefined' && this.alignmentBucketFilter !== null) {
      toReturn['alignmentBucketFilter'] = 'toApiJson' in this.alignmentBucketFilter ? this.alignmentBucketFilter.toApiJson() : this.alignmentBucketFilter;
    }
    if (typeof this.skipFilteringEntitiesToDateRange !== 'undefined') {
      toReturn['skipFilteringEntitiesToDateRange'] = this.skipFilteringEntitiesToDateRange;
    }
    return toReturn;
  }
}
class DateRange {
  static fromProto(proto) {
    let m = new DateRange();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.startExclusive) {
      m.startExclusive = new Date(proto.startExclusive);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    if (proto.endExclusive) {
      m.endExclusive = new Date(proto.endExclusive);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.startExclusive !== 'undefined' && this.startExclusive !== null) {
      toReturn['startExclusive'] = 'toApiJson' in this.startExclusive ? this.startExclusive.toApiJson() : this.startExclusive;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    if (typeof this.endExclusive !== 'undefined' && this.endExclusive !== null) {
      toReturn['endExclusive'] = 'toApiJson' in this.endExclusive ? this.endExclusive.toApiJson() : this.endExclusive;
    }
    return toReturn;
  }
}
class GroupByDimension {
  static fromProto(proto) {
    let m = new GroupByDimension();
    m = Object.assign(m, proto);
    if (proto.limitDimension) {
      m.limitDimension = GroupByLimit.fromProto(proto.limitDimension);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.limitDimension !== 'undefined' && this.limitDimension !== null) {
      toReturn['limitDimension'] = 'toApiJson' in this.limitDimension ? this.limitDimension.toApiJson() : this.limitDimension;
    }
    return toReturn;
  }
}
class GroupByExcludeCombination {
  static fromProto(proto) {
    let m = new GroupByExcludeCombination();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dimensions !== 'undefined') {
      toReturn['dimensions'] = this.dimensions;
    }
    return toReturn;
  }
}
class FieldFilter {
  static fromProto(proto) {
    let m = new FieldFilter();
    m = Object.assign(m, proto);
    if (proto.operator) {
      m.operator = enumStringToValue(FieldFilterOperator, proto.operator);
    }
    if (proto.value) {
      m.value = TypedValue.fromProto(proto.value);
    }
    if (proto.operatorFunction) {
      m.operatorFunction = enumStringToValue(FieldFilterOperatorFunction, proto.operatorFunction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.operator !== 'undefined') {
      toReturn['operator'] = this.operator;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    if (typeof this.comparisonField !== 'undefined') {
      toReturn['comparisonField'] = this.comparisonField;
    }
    if (typeof this.operatorFunction !== 'undefined') {
      toReturn['operatorFunction'] = this.operatorFunction;
    }
    if (typeof this.operatorFunctionOnField !== 'undefined') {
      toReturn['operatorFunctionOnField'] = this.operatorFunctionOnField;
    }
    return toReturn;
  }
}
class Filter {
  static fromProto(proto) {
    let m = new Filter();
    m = Object.assign(m, proto);
    if (proto.compositeFilter) {
      m.compositeFilter = CompositeFilter.fromProto(proto.compositeFilter);
    }
    if (proto.fieldFilter) {
      m.fieldFilter = FieldFilter.fromProto(proto.fieldFilter);
    }
    if (proto.unaryFilter) {
      m.unaryFilter = UnaryFilter.fromProto(proto.unaryFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.compositeFilter !== 'undefined' && this.compositeFilter !== null) {
      toReturn['compositeFilter'] = 'toApiJson' in this.compositeFilter ? this.compositeFilter.toApiJson() : this.compositeFilter;
    }
    if (typeof this.fieldFilter !== 'undefined' && this.fieldFilter !== null) {
      toReturn['fieldFilter'] = 'toApiJson' in this.fieldFilter ? this.fieldFilter.toApiJson() : this.fieldFilter;
    }
    if (typeof this.unaryFilter !== 'undefined' && this.unaryFilter !== null) {
      toReturn['unaryFilter'] = 'toApiJson' in this.unaryFilter ? this.unaryFilter.toApiJson() : this.unaryFilter;
    }
    return toReturn;
  }
}
class Filters {
  static fromProto(proto) {
    let m = new Filters();
    m = Object.assign(m, proto);
    if (proto.sourceFilters) {
      m.sourceFilters = SourceFilters.fromProto(proto.sourceFilters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceFilters !== 'undefined' && this.sourceFilters !== null) {
      toReturn['sourceFilters'] = 'toApiJson' in this.sourceFilters ? this.sourceFilters.toApiJson() : this.sourceFilters;
    }
    return toReturn;
  }
}
class GetMetricsRequest {
  static fromProto(proto) {
    let m = new GetMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = proto.metrics.map(v => enumStringToValue(Metric, v));
    }
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.dateRange) {
      m.dateRange = DateRange.fromProto(proto.dateRange);
    }
    if (proto.businessLimit) {
      m.businessLimit = parseInt(proto.businessLimit, 10);
    }
    if (proto.filters) {
      m.filters = Filters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metrics !== 'undefined') {
      toReturn['metrics'] = this.metrics;
    }
    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] = 'toApiJson' in this.resourceIds ? this.resourceIds.toApiJson() : this.resourceIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    if (typeof this.includeTimeBuckets !== 'undefined') {
      toReturn['includeTimeBuckets'] = this.includeTimeBuckets;
    }
    if (typeof this.includeGroupsBusinesses !== 'undefined') {
      toReturn['includeGroupsBusinesses'] = this.includeGroupsBusinesses;
    }
    if (typeof this.businessLimit !== 'undefined') {
      toReturn['businessLimit'] = this.businessLimit;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class GetMetricsResponse {
  static fromProto(proto) {
    let m = new GetMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.metrics) {
      m.metrics = proto.metrics.map(v => enumStringToValue(Metric, v));
    }
    if (proto.resourceResponses) {
      m.resourceResponses = proto.resourceResponses.map(ResourceMetricsResponse.fromProto);
    }
    if (proto.timeBucketStarts) {
      m.timeBucketStarts = proto.timeBucketStarts.map(d => new Date(d));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] = 'toApiJson' in this.resourceIds ? this.resourceIds.toApiJson() : this.resourceIds;
    }
    if (typeof this.metrics !== 'undefined') {
      toReturn['metrics'] = this.metrics;
    }
    if (typeof this.resourceResponses !== 'undefined' && this.resourceResponses !== null) {
      toReturn['resourceResponses'] = 'toApiJson' in this.resourceResponses ? this.resourceResponses.toApiJson() : this.resourceResponses;
    }
    if (typeof this.timeBucketStarts !== 'undefined' && this.timeBucketStarts !== null) {
      toReturn['timeBucketStarts'] = 'toApiJson' in this.timeBucketStarts ? this.timeBucketStarts.toApiJson() : this.timeBucketStarts;
    }
    return toReturn;
  }
}
class GroupBy {
  static fromProto(proto) {
    let m = new GroupBy();
    m = Object.assign(m, proto);
    if (proto.dimension) {
      m.dimension = proto.dimension.map(GroupByDimension.fromProto);
    }
    if (proto.groupByOperator) {
      m.groupByOperator = enumStringToValue(GroupByOperator, proto.groupByOperator);
    }
    if (proto.excludeCombination) {
      m.excludeCombination = proto.excludeCombination.map(GroupByExcludeCombination.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dimension !== 'undefined' && this.dimension !== null) {
      toReturn['dimension'] = 'toApiJson' in this.dimension ? this.dimension.toApiJson() : this.dimension;
    }
    if (typeof this.groupByOperator !== 'undefined') {
      toReturn['groupByOperator'] = this.groupByOperator;
    }
    if (typeof this.excludeCombination !== 'undefined' && this.excludeCombination !== null) {
      toReturn['excludeCombination'] = 'toApiJson' in this.excludeCombination ? this.excludeCombination.toApiJson() : this.excludeCombination;
    }
    return toReturn;
  }
}
class GroupResourceId {
  static fromProto(proto) {
    let m = new GroupResourceId();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupPathNodes !== 'undefined') {
      toReturn['groupPathNodes'] = this.groupPathNodes;
    }
    return toReturn;
  }
}
class JWTResourceId {
  static fromProto(proto) {
    let m = new JWTResourceId();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jwt !== 'undefined') {
      toReturn['jwt'] = this.jwt;
    }
    return toReturn;
  }
}
class GroupByLimit {
  static fromProto(proto) {
    let m = new GroupByLimit();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = enumStringToValue(Order, proto.order);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.order !== 'undefined') {
      toReturn['order'] = this.order;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
class MarketId {
  static fromProto(proto) {
    let m = new MarketId();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class Measure {
  static fromProto(proto) {
    let m = new Measure();
    m = Object.assign(m, proto);
    if (proto.aggregate) {
      m.aggregate = MeasureAggregate.fromProto(proto.aggregate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.measure !== 'undefined') {
      toReturn['measure'] = this.measure;
    }
    if (typeof this.aggregate !== 'undefined' && this.aggregate !== null) {
      toReturn['aggregate'] = 'toApiJson' in this.aggregate ? this.aggregate.toApiJson() : this.aggregate;
    }
    return toReturn;
  }
}
class MetricResult {
  static fromProto(proto) {
    let m = new MetricResult();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = Metrics.fromProto(proto.results);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    if (typeof this.measures !== 'undefined') {
      toReturn['measures'] = this.measures;
    }
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
class Metrics {
  static fromProto(proto) {
    let m = new Metrics();
    m = Object.assign(m, proto);
    if (proto.metrics) {
      m.metrics = proto.metrics.map(MetricResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? this.metrics.toApiJson() : this.metrics;
    }
    return toReturn;
  }
}
class OrderBy {
  static fromProto(proto) {
    let m = new OrderBy();
    m = Object.assign(m, proto);
    if (proto.orderBy) {
      m.orderBy = proto.orderBy.map(OrderByOrderColumn.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderBy !== 'undefined' && this.orderBy !== null) {
      toReturn['orderBy'] = 'toApiJson' in this.orderBy ? this.orderBy.toApiJson() : this.orderBy;
    }
    return toReturn;
  }
}
class OrderByOrderColumn {
  static fromProto(proto) {
    let m = new OrderByOrderColumn();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = enumStringToValue(Order, proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.column !== 'undefined') {
      toReturn['column'] = this.column;
    }
    if (typeof this.order !== 'undefined') {
      toReturn['order'] = this.order;
    }
    return toReturn;
  }
}
class QueryMetricsRequest {
  static fromProto(proto) {
    let m = new QueryMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.resourceIds) {
      m.resourceIds = proto.resourceIds.map(ResourceId.fromProto);
    }
    if (proto.filter) {
      m.filter = Filter.fromProto(proto.filter);
    }
    if (proto.measures) {
      m.measures = proto.measures.map(Measure.fromProto);
    }
    if (proto.alignmentPeriod) {
      m.alignmentPeriod = AlignmentPeriod.fromProto(proto.alignmentPeriod);
    }
    if (proto.alignment) {
      m.alignment = enumStringToValue(Alignment, proto.alignment);
    }
    if (proto.groupBy) {
      m.groupBy = GroupBy.fromProto(proto.groupBy);
    }
    if (proto.dateRange) {
      m.dateRange = DateRange.fromProto(proto.dateRange);
    }
    if (proto.timeRange) {
      m.timeRange = DateRange.fromProto(proto.timeRange);
    }
    if (proto.orderBy) {
      m.orderBy = OrderBy.fromProto(proto.orderBy);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    if (proto.customAligner) {
      m.customAligner = CustomAlignerConfig.fromProto(proto.customAligner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.metricName !== 'undefined') {
      toReturn['metricName'] = this.metricName;
    }
    if (typeof this.resourceIds !== 'undefined' && this.resourceIds !== null) {
      toReturn['resourceIds'] = 'toApiJson' in this.resourceIds ? this.resourceIds.toApiJson() : this.resourceIds;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.measures !== 'undefined' && this.measures !== null) {
      toReturn['measures'] = 'toApiJson' in this.measures ? this.measures.toApiJson() : this.measures;
    }
    if (typeof this.alignmentPeriod !== 'undefined' && this.alignmentPeriod !== null) {
      toReturn['alignmentPeriod'] = 'toApiJson' in this.alignmentPeriod ? this.alignmentPeriod.toApiJson() : this.alignmentPeriod;
    }
    if (typeof this.alignment !== 'undefined') {
      toReturn['alignment'] = this.alignment;
    }
    if (typeof this.groupBy !== 'undefined' && this.groupBy !== null) {
      toReturn['groupBy'] = 'toApiJson' in this.groupBy ? this.groupBy.toApiJson() : this.groupBy;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    if (typeof this.timeRange !== 'undefined' && this.timeRange !== null) {
      toReturn['timeRange'] = 'toApiJson' in this.timeRange ? this.timeRange.toApiJson() : this.timeRange;
    }
    if (typeof this.orderBy !== 'undefined' && this.orderBy !== null) {
      toReturn['orderBy'] = 'toApiJson' in this.orderBy ? this.orderBy.toApiJson() : this.orderBy;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.customAligner !== 'undefined' && this.customAligner !== null) {
      toReturn['customAligner'] = 'toApiJson' in this.customAligner ? this.customAligner.toApiJson() : this.customAligner;
    }
    return toReturn;
  }
}
class QueryMetricsResponse {
  static fromProto(proto) {
    let m = new QueryMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.metricResults) {
      m.metricResults = proto.metricResults.map(ResourceMetricResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.metricResults !== 'undefined' && this.metricResults !== null) {
      toReturn['metricResults'] = 'toApiJson' in this.metricResults ? this.metricResults.toApiJson() : this.metricResults;
    }
    return toReturn;
  }
}
class ResourceId {
  static fromProto(proto) {
    let m = new ResourceId();
    m = Object.assign(m, proto);
    if (proto.groupId) {
      m.groupId = GroupResourceId.fromProto(proto.groupId);
    }
    if (proto.businessId) {
      m.businessId = BusinessResourceId.fromProto(proto.businessId);
    }
    if (proto.marketId) {
      m.marketId = MarketId.fromProto(proto.marketId);
    }
    if (proto.jwtId) {
      m.jwtId = JWTResourceId.fromProto(proto.jwtId);
    }
    if (proto.salesTeam) {
      m.salesTeam = SalesTeam.fromProto(proto.salesTeam);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupId !== 'undefined' && this.groupId !== null) {
      toReturn['groupId'] = 'toApiJson' in this.groupId ? this.groupId.toApiJson() : this.groupId;
    }
    if (typeof this.businessId !== 'undefined' && this.businessId !== null) {
      toReturn['businessId'] = 'toApiJson' in this.businessId ? this.businessId.toApiJson() : this.businessId;
    }
    if (typeof this.marketId !== 'undefined' && this.marketId !== null) {
      toReturn['marketId'] = 'toApiJson' in this.marketId ? this.marketId.toApiJson() : this.marketId;
    }
    if (typeof this.jwtId !== 'undefined' && this.jwtId !== null) {
      toReturn['jwtId'] = 'toApiJson' in this.jwtId ? this.jwtId.toApiJson() : this.jwtId;
    }
    if (typeof this.salesTeam !== 'undefined' && this.salesTeam !== null) {
      toReturn['salesTeam'] = 'toApiJson' in this.salesTeam ? this.salesTeam.toApiJson() : this.salesTeam;
    }
    return toReturn;
  }
}
class ResourceMetricResult {
  static fromProto(proto) {
    let m = new ResourceMetricResult();
    m = Object.assign(m, proto);
    if (proto.resourceId) {
      m.resourceId = ResourceId.fromProto(proto.resourceId);
    }
    if (proto.measuresSchema) {
      m.measuresSchema = Schema.fromProto(proto.measuresSchema);
    }
    if (proto.dimensionsSchema) {
      m.dimensionsSchema = Schema.fromProto(proto.dimensionsSchema);
    }
    if (proto.metrics) {
      m.metrics = Metrics.fromProto(proto.metrics);
    }
    if (proto.explodedMetrics) {
      m.explodedMetrics = QueryMetricsResponse.fromProto(proto.explodedMetrics);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceId !== 'undefined' && this.resourceId !== null) {
      toReturn['resourceId'] = 'toApiJson' in this.resourceId ? this.resourceId.toApiJson() : this.resourceId;
    }
    if (typeof this.measuresSchema !== 'undefined' && this.measuresSchema !== null) {
      toReturn['measuresSchema'] = 'toApiJson' in this.measuresSchema ? this.measuresSchema.toApiJson() : this.measuresSchema;
    }
    if (typeof this.dimensionsSchema !== 'undefined' && this.dimensionsSchema !== null) {
      toReturn['dimensionsSchema'] = 'toApiJson' in this.dimensionsSchema ? this.dimensionsSchema.toApiJson() : this.dimensionsSchema;
    }
    if (typeof this.metrics !== 'undefined' && this.metrics !== null) {
      toReturn['metrics'] = 'toApiJson' in this.metrics ? this.metrics.toApiJson() : this.metrics;
    }
    if (typeof this.explodedMetrics !== 'undefined' && this.explodedMetrics !== null) {
      toReturn['explodedMetrics'] = 'toApiJson' in this.explodedMetrics ? this.explodedMetrics.toApiJson() : this.explodedMetrics;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ResourceMetricsResponse {
  static fromProto(proto) {
    let m = new ResourceMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.timeBuckets) {
      m.timeBuckets = proto.timeBuckets.map(TimeBucketMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.timeBuckets !== 'undefined' && this.timeBuckets !== null) {
      toReturn['timeBuckets'] = 'toApiJson' in this.timeBuckets ? this.timeBuckets.toApiJson() : this.timeBuckets;
    }
    return toReturn;
  }
}
class SalesTeam {
  static fromProto(proto) {
    let m = new SalesTeam();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesTeamIds !== 'undefined') {
      toReturn['salesTeamIds'] = this.salesTeamIds;
    }
    return toReturn;
  }
}
class SourceFilters {
  static fromProto(proto) {
    let m = new SourceFilters();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    return toReturn;
  }
}
class TimeBucketMetrics {
  static fromProto(proto) {
    let m = new TimeBucketMetrics();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class TypedValue {
  static fromProto(proto) {
    let m = new TypedValue();
    m = Object.assign(m, proto);
    if (proto.valueType) {
      m.valueType = enumStringToValue(PropertyType, proto.valueType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.valueType !== 'undefined') {
      toReturn['valueType'] = this.valueType;
    }
    return toReturn;
  }
}
class UnaryFilter {
  static fromProto(proto) {
    let m = new UnaryFilter();
    m = Object.assign(m, proto);
    if (proto.op) {
      m.op = enumStringToValue(UnaryFilterOperator, proto.op);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.op !== 'undefined') {
      toReturn['op'] = this.op;
    }
    if (typeof this.dimension !== 'undefined') {
      toReturn['dimension'] = this.dimension;
    }
    return toReturn;
  }
}

// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'multi-location-analytics-api.vendasta-local.com',
  'test': '',
  'demo': 'multi-location-analytics-api-demo.apigateway.co',
  'prod': 'multi-location-analytics-api-prod.apigateway.co',
  'production': 'multi-location-analytics-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let AnalyticsApiService = /*#__PURE__*/(() => {
  class AnalyticsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMetrics(r) {
      const request = r.toApiJson ? r : new GetMetricsRequest(r);
      return this.http.post(this._host + "/multilocationanalytics.v1.AnalyticsService/GetMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMetricsResponse.fromProto(resp)));
    }
    queryMetrics(r) {
      const request = r.toApiJson ? r : new QueryMetricsRequest(r);
      return this.http.post(this._host + "/multilocationanalytics.v1.AnalyticsService/QueryMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => QueryMetricsResponse.fromProto(resp)));
    }
  }
  AnalyticsApiService.ɵfac = function AnalyticsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AnalyticsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AnalyticsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AnalyticsApiService,
    factory: AnalyticsApiService.ɵfac,
    providedIn: 'root'
  });
  return AnalyticsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************

const ResourceIdFieldTypeMap = new Map([['GroupResourceId', 'groupId'], ['BusinessResourceId', 'businessId'], ['MarketId', 'marketId'], ['JWTResourceId', 'jwtId'], ['SalesTeam', 'salesTeam']]);
let MultiLocationAnalyticsService = /*#__PURE__*/(() => {
  class MultiLocationAnalyticsService {
    constructor(api) {
      this.api = api;
    }
    queryMetrics(request) {
      return this.api.queryMetrics(request);
    }
    /**
     * Strips a Metric response down to the Metric result array
     */
    unwrapMetricsResponse(res) {
      if (res && res.metricResults && res.metricResults.length > 0) {
        if (res.metricResults[0].metrics && res.metricResults[0].metrics.metrics) {
          return res.metricResults[0].metrics.metrics;
        }
      }
      return [];
    }
    /**
     * Returns a boolean filter to test if <fieldName> is <value>
     */
    boolFilter(fieldName, value) {
      return new Filter({
        fieldFilter: new FieldFilter({
          dimension: fieldName,
          operator: FieldFilterOperator.EQUAL,
          value: this.typedValue(value, PropertyType.PROPERTY_TYPE_BOOL)
        })
      });
    }
    /**
     * Returns a string filter to test if <fieldName> is equal to <value>
     */
    isEqualFilter(fieldName, value) {
      return new Filter({
        fieldFilter: new FieldFilter({
          dimension: fieldName,
          operator: FieldFilterOperator.EQUAL,
          value: this.typedValue(value, PropertyType.PROPERTY_TYPE_STRING)
        })
      });
    }
    /**
     * Returns a string filter to test if <fieldName> is NOT equal to <value>
     */
    isNotEqualFilter(fieldName, value) {
      return new Filter({
        fieldFilter: new FieldFilter({
          dimension: fieldName,
          operator: FieldFilterOperator.NOT_EQUAL,
          value: this.typedValue(value, PropertyType.PROPERTY_TYPE_STRING)
        })
      });
    }
    /**
     * Returns a unary filter to determine if <fieldName> is null
     */
    isNullFilter(fieldName) {
      return new Filter({
        unaryFilter: new UnaryFilter({
          op: UnaryFilterOperator.IS_NULL,
          dimension: fieldName
        })
      });
    }
    /**
     * Returns a filter to determine if value is contained in fieldName, where fieldName is stored as an Array
     */
    anyFieldFilter(fieldName, value) {
      return new Filter({
        fieldFilter: new FieldFilter({
          dimension: fieldName,
          operator: FieldFilterOperator.EQUAL,
          value: this.typedValue(value, PropertyType.PROPERTY_TYPE_STRING),
          operatorFunction: FieldFilterOperatorFunction.ANY,
          operatorFunctionOnField: true
        })
      });
    }
    /**
     * Returns a unary filter to determine if <fieldName> is NOT null
     */
    isNotNullFilter(fieldName) {
      return new Filter({
        unaryFilter: new UnaryFilter({
          op: UnaryFilterOperator.IS_NOT_NULL,
          dimension: fieldName
        })
      });
    }
    /**
     * Returns a date filter to determine if <fieldName> <operator> <value>
     *     ie, is <due_date> <LESS THAN> <today>?
     */
    dateFilter(fieldName, value, op) {
      return new Filter({
        fieldFilter: new FieldFilter({
          dimension: fieldName,
          operator: op,
          value: this.typedValue(value, PropertyType.PROPERTY_TYPE_TIMESTAMP)
        })
      });
    }
    /**
     * Returns a composite filter of the provided filters with <op> applied.
     * This can be used to AND or OR a group of filters together.
     */
    buildCompositeFilter(filters, op) {
      return new Filter({
        compositeFilter: new CompositeFilter({
          op: op,
          filters: filters
        })
      });
    }
    /**
     * Returns a single ResourceId.
     *
     * Writes to the appropriate field of ResourceId based on type passed in
     */
    buildResourceId(value) {
      return new ResourceId({
        [ResourceIdFieldTypeMap.get(value.constructor.name) || '']: value
      });
    }
    /**
     * Returns a MeasureAggregate.
     */
    buildMeasureAggregate(measure, aggOp, filter, alias) {
      return new Measure({
        aggregate: new MeasureAggregate({
          measure: measure,
          aggOp: aggOp,
          filter: filter,
          alias: alias
        })
      });
    }
    /**
     * Returns a single Measure.
     */
    buildMeasure(measure) {
      return new Measure({
        measure: measure
      });
    }
    /**
     * Returns the dimensions provided as a GroupBy object
     */
    buildGroupBy(dimensions, groupByOperator) {
      return new GroupBy({
        dimension: dimensions,
        groupByOperator: groupByOperator
      });
    }
    typedValue(value, valueType) {
      return new TypedValue({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: value,
        valueType: valueType
      });
    }
  }
  MultiLocationAnalyticsService.ɵfac = function MultiLocationAnalyticsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MultiLocationAnalyticsService)(i0.ɵɵinject(AnalyticsApiService));
  };
  MultiLocationAnalyticsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MultiLocationAnalyticsService,
    factory: MultiLocationAnalyticsService.ɵfac,
    providedIn: 'root'
  });
  return MultiLocationAnalyticsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Alignment, AlignmentPeriod, AlignmentPeriodCalendar, AnalyticsApiService, BusinessResourceId, CompositeFilter, CompositeFilterOperator, CustomAlignerConfig, DateRange, FieldFilter, FieldFilterOperator, FieldFilterOperatorFunction, Filter, Filters, GetMetricsRequest, GetMetricsResponse, GroupBy, GroupByDimension, GroupByExcludeCombination, GroupByLimit, GroupByOperator, GroupResourceId, JWTResourceId, MarketId, Measure, MeasureAggregate, MeasureAggregateOperator, Metric, MetricResult, Metrics, MultiLocationAnalyticsService, Order, OrderBy, OrderByOrderColumn, Property, PropertyPIITag, PropertyType, QueryMetricsRequest, QueryMetricsResponse, ResourceId, ResourceMetricResult, ResourceMetricsResponse, SalesTeam, Schema, SourceFilters, TimeBucketMetrics, TypedStruct, TypedValue, UnaryFilter, UnaryFilterOperator };
